module.exports = __webpack_public_path__ + "static/media/bella.0025b890.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/bella.jpeg
// module id = 273
// module chunks = 0